import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import scale from 'assets/images/scale.png'
import pointer from 'assets/images/pointer.png'
import { STRESS_SCORE_TEXT_MAP } from 'root-constants'
import { useStressLevelPoints } from 'hooks/useStressLevelPoints'
import { StyledStressScore as S } from './StressScore.styles'
import { POINTER_COORDINATES_MAP, SCALE_VALUES } from './constants'

export const StressScore: React.FC = () => {
  const { t } = useTranslation()
  const stressValue = useStressLevelPoints()

  const { stressTextKey } = useMemo(() => {
    return STRESS_SCORE_TEXT_MAP[stressValue]
  }, [stressValue])

  const { rotationAngle, left, bottom, minPhoneBottom } = useMemo(
    () => POINTER_COORDINATES_MAP[stressValue],
    [stressValue],
  )

  return (
    <div>
      <S.Title>{t`result.stressScore.title`}</S.Title>
      <S.ImageContainer>
        <S.Scale src={scale} alt="scale" />
        <S.Pointer
          src={pointer}
          alt="pointer"
          rotationAngle={rotationAngle}
          left={left}
          bottom={bottom}
          minPhoneBottom={minPhoneBottom}
        />
        <S.Text>
          {stressValue}
          <br />
          {t(stressTextKey as any)}
        </S.Text>
        {SCALE_VALUES.map(
          ({ id, maxWidth, bottomValue, firstValue, secondValue }) => (
            <S.ScaleValueContainer
              key={id}
              maxWidth={maxWidth}
              bottomValue={bottomValue}
            >
              <S.ScaleValue isActive={firstValue === stressValue}>
                {firstValue}
              </S.ScaleValue>
              <S.ScaleValue isActive={secondValue === stressValue}>
                {secondValue}
              </S.ScaleValue>
            </S.ScaleValueContainer>
          ),
        )}
      </S.ImageContainer>
    </div>
  )
}
